import { createPlugin } from '@backstage/core-plugin-api';

import { notificationApiFactory } from './api/notificationApi';

export const notificationBellPlugin = createPlugin({
  id: 'notification-bell',
  apis: [notificationApiFactory],
});
